import { styled } from '@mui/system';
import { Tab } from '@mui/material';

export const StyledTab = styled(Tab)(({ theme }) => ({
  ...theme.typography.h6,
  height: 56,
  padding: 12,
  color: theme.colors.white,
  cursor: 'pointer',
  transition: 'background-color 0.2s ease-in-out, color 0.2s ease-in-out',

  '&.Mui-selected, &:hover': {
    backgroundColor: theme.palette.background.hover,
    color: theme.colors.blue,
  },

  '&:last-of-type': {
    borderRadius: '0 8px 8px 0',
  },
  '&:first-of-type': {
    borderRadius: '8px 0 0 8px',
  },
}));
